import type { PropsWithChildren } from 'react';
import { Header } from './header';
import { twMerge } from 'tailwind-merge';

interface ContentHeaderProps extends PropsWithChildren {
  title: string;
  className?: string;
}

export const ContentHeader = ({
  title,
  children,
  className,
}: ContentHeaderProps) => {
  return (
    <div className="flex w-full flex-1 flex-col">
      <Header title={title} />
      <div
        className={twMerge(
          'flex w-full flex-1 flex-col items-center',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};
